'use client';

import AppLayout from '@/components/AppLayout';
import RouteGuard from '@/components/RouteGuard';
import AuditLogsContent from './components/AuditLogsContent';

export default function AuditLogsPage() {
  return (
    <RouteGuard allowedRoles={['Administrateur']} redirectTo="/liste-des-locaux">
      <AppLayout>
        <AuditLogsContent />
      </AppLayout>
    </RouteGuard>
  );
}
